import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import format from "date-fns/format";
import { Entity } from "models/entity";

import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";

import { SKSpinner } from "components/customElements/skSpinner";
import FontAwesomeIcon from "components/FontAwesomeIcon";
import { useApi } from "hooks/useApi";
import { baseFetcher } from "utils/baseFetcher";

import { estimatesUrl } from "../utils";

interface NextEarningTextProps {
  entity: Entity;
}

const NextEarningText = ({ entity }: NextEarningTextProps) => {
  const { data: estimatesData, isValidating } = useApi(
    estimatesUrl(entity.id),
    baseFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const { next_earn } = estimatesData || {};

  if (!isValidating && !estimatesData) return <></>;

  return (
    <div className="flex space-x-[5px]">
      {isValidating ? (
        <SKSpinner showLoading={false} />
      ) : (
        next_earn?.date && (
          <>
            <div className="text-[15px] font-medium flex-1">
              Next Earnings Date:
            </div>
            <OverlayTrigger
              overlay={
                next_earn.status?.toLowerCase() === "confirmed" ? (
                  <Tooltip>Confirmed Earnings Date</Tooltip>
                ) : next_earn.when ? (
                  <></>
                ) : (
                  <Tooltip>Estimated Earnings Date</Tooltip>
                )
              }
            >
              <div className="text-[15px]">
                {format(new Date(next_earn.date), "dd MMM yyyy")}{" "}
                {next_earn.status?.toLowerCase() === "confirmed" ? (
                  <div className="inline-block">
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-bullish-green"
                    />
                  </div>
                ) : next_earn.when ? (
                  `(${next_earn.when})`
                ) : (
                  <div className="inline-block">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                  </div>
                )}
              </div>
            </OverlayTrigger>
          </>
        )
      )}
    </div>
  );
};

export default NextEarningText;
